import { IQuoteEditorFormData, IQuotePricingConfig, IToolSearchResult } from 'types/quoteEditor.types';
import DeviceDescription from '../../../RequestedDevice/DeviceDescription/DeviceDescription';
import QuoteEditorForm from '../../../QuoteEditorForm/QuoteEditorForm';
import SelectedToolHeader from '../SelectedToolHeader/SelectedToolHeader';
import './QuoteSelectedTool.scss';

interface IQuoteSelectedTool {
  tool: IToolSearchResult;
  formData: IQuoteEditorFormData;
  requestedUnits: number;
  pricingConfig: IQuotePricingConfig;
  isFormDisabled?: boolean;
  onChangeTool: () => void;
  onFormChange: (formData: IQuoteEditorFormData) => void;
}

/**
 * Muestra la herramienta seleccionada con sus datos principales, el grid de specs
 * del catálogo y el formulario de cotización.
 * Si la herramienta está activa en tienda, muestra un badge y bloquea los campos de pricing del catálogo.
 */
const QuoteSelectedTool = ({
  tool,
  formData,
  requestedUnits,
  pricingConfig,
  isFormDisabled,
  onChangeTool,
  onFormChange
}: IQuoteSelectedTool) => (
  <div className="quoteSelectedTool">
    <SelectedToolHeader tool={tool} onChangeTool={onChangeTool} isChangeToolDisabled={isFormDisabled} />
    <DeviceDescription toolResult={tool} />
    <QuoteEditorForm
      formData={formData}
      requestedUnits={requestedUnits}
      pricingConfig={pricingConfig}
      categoryName={tool.category}
      isActiveInStore={tool.status === 'active'}
      isFormDisabled={isFormDisabled}
      onChange={onFormChange}
    />
  </div>
);

export default QuoteSelectedTool;
